export default __webpack_public_path__ + "static/media/secondary.81909b76d3a2deff57618adef20ade9d.svg";